module.exports = __webpack_public_path__ + "assets/img/wh5_p09.37b71a52.jpg";